export const qaAttribute = 'data-qa-tag';

// common
export const SUPPORT_CHAT_WINDOW = 'support-chat-window';
export const SUPPORT_CHAT_BUTTON = 'support-chat-button';

// Chat header
export const DOWNLOAD_CHAT_BUTTON = 'download-chat-button';
export const HIDE_CHAT_BUTTON = 'hide-chat-button';
export const CLOSE_CHAT_BUTTON = 'close-chat-button';
export const CHAT_HEADER = 'chat-header';

export const CHAT_HEADER_MENU = 'chat-header-menu';

// Chat popup
export const CHAT_POPUP = 'chat-popup';
export const CHAT_POPUP_CLOSE = 'chat-popup-close';
export const CHAT_POPUP_CHILDREN = 'chat-popup-children';

// Rating
export const CHAT_RATING_LIST = 'chat-rating-list';
export const RATING_1 = 'chat-set-rating-1';
export const RATING_2 = 'chat-set-rating-2';
export const RATING_3 = 'chat-set-rating-3';
export const RATING_4 = 'chat-set-rating-4';
export const RATING_5 = 'chat-set-rating-5';

// Chat message
export const ATTACHMENT_BUTTON = 'chat-attachment-button';
export const CHAT_MESSAGE_FORM = 'chat-message-form';
export const SEND_CHAT_MESSAGE = 'send-chat-message';

// Chat modal
export const CHAT_MODAL_OVERLAY = 'chat-modal-overlay';
export const CHAT_MODAL_CLOSE_CONFIRM = 'chat-confirm-close';
export const CHAT_MODAL_CANCEL = 'chat-cancel-close';

export const CHAT_MODAL_FEEDBACK_TEXTAREA = 'chat-modal-feedback-textarea';

export const CHAT_MODAL_FEEDBACK_SEND = 'chat-modal-feedback-send';
export const CHAT_MODAL_FEEDBACK_CANCEL = 'chat-modal-feedback-cancel';

// Chat ticket

export const CHAT_TICKET_EMAIL_INPUT = 'chat-ticket-email-input';
export const CHAT_TICKET_SUBJECT_INPUT = 'chat-ticket-subject-input';
export const CHAT_TICKET_MESSAGE_INPUT = 'chat-ticket-message-input';
export const CHAT_TICKET_SEND = 'chat-ticket-send';
export const CHAT_TICKET_GO_TO_HELP_CENTER = 'chat-ticket-go-to-help-center';

// Chat callback
export const CHAT_CALLBACK_ALLOW = 'chat-callback-allow';
export const CHAT_CALLBACK_CANCEL = 'chat-callback-cancel';

// Chat email request
export const CHAT_EMAIL_REQUEST_INPUT = 'chat-email-request-input';
export const CHAT_EMAIL_SEND = 'chat-email-send';

// init menu buttons

export const SUPPORT_CHAT_OPEN_HELP_CENTER = 'support-chat-open-help-center';
export const SUPPORT_CHAT_REQUEST_A_DEMO = 'support-chat-request-a-demo';
export const SUPPORT_CHAT_CONTACT_SUPPORT = 'support-chat-contact-support';
